import { Heading3, P, Ul, Li, TextLink } from '@ovotech/nebula';
import React from 'react';
import Offer from './Offer/Offer';
import image from '@/src/resources/offers/homeHeat.png';

export const HomeHeatOffer = () => {
  // TODO: check if reference to smart thermostat can be removed
  return (
    <Offer
      image={image}
      offerId="homeHeat"
      linkUrl="https://corgihomeheat.co.uk/quote"
      linkText="Get a quote"
    >
      <Heading3 as="h2">New A-rated boiler: £400 off</Heading3>
      <P>
        Is your boiler unreliable or in need of an upgrade? Save £400 on the
        cost of a new energy-efficient boiler and unlock a free annual boiler
        service worth £84.
      </P>
      <P>
        What’s included
        <Ul>
          <Li>
            Get an A-rated boiler that could save you up to £500 a year on
            energy
          </Li>
          <Li>Installation by a Gas Safe engineer</Li>
          <Li>Up to 10 years warranty on parts and labour</Li>
          <Li>
            A smart thermostat to control your home heating (worth £149 RRP)
          </Li>
          <Li>
            A magnetic filter and corrosion inhibitor to keep your system clear
            and efficient
          </Li>
        </Ul>
      </P>
      <P>
        Call on <TextLink href="tel:0800 085 6398"> 0800 085 6398</TextLink> for
        any queries.
      </P>
    </Offer>
  );
};
